import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GurdServiceService } from './gurd-service.service';
import { NotificationService } from './notification.service';

@Injectable()
export class SignalrImageService {
  private hubConnection?: HubConnection;
  private hubStatus = new BehaviorSubject<boolean | null>(false);
  readonly isHubConnected$ = this.hubStatus.asObservable();
  private hubError = new Subject<any>();
  readonly hubError$ = this.hubError.asObservable();
  private mobileImageReceived = new Subject<any>();
  readonly mobileImageReceived$ = this.mobileImageReceived.asObservable();

  constructor(
    private authService: GurdServiceService,
    private notification: NotificationService,
  ) {}

  init(): void {
    const baseUrl = environment.imageUrlHub?.trim().replace(/\/+$/, '');
    const user = this.authService.decrypt(localStorage.getItem('ID'));
    const password = this.authService.decrypt(localStorage.getItem('pass'));
    if (!baseUrl || !user || !password) return;

    this.hubConnection = new HubConnectionBuilder()
      .withUrl(`${baseUrl}/FleetYarCameraHub?iSystemUser=${user}&strUserPassword=${password}`)
      .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
      .build();
    this.hubConnection.on('HC_HubError', (data: any) => this.hubError.next(data));
    this.hubConnection.on('HC_MobileImageReceived', (data: any) => this.mobileImageReceived.next(data));
    this.hubConnection.onreconnecting(() => this.hubStatus.next(false));
    this.hubConnection.onreconnected(() => this.hubStatus.next(true));
    this.hubConnection.onclose(() => this.hubStatus.next(false));
    this.hubConnection.start()
      .then(() => {
        this.hubStatus.next(true);
        this.notification.showSuccess('اتصال موفق به هاب دوربین‌ها');
      })
      .catch((error) => {
        this.hubStatus.next(false);
        console.error('Error while starting image hub connection:', error);
        this.notification.showError('عدم امکان اتصال به هاب دوربین‌ها');
      });
  }

  async disconnect(): Promise<void> {
    try {
      await this.hubConnection?.stop();
    } catch (error) {
      console.error('Error while stopping image hub:', error);
    }
  }
}
